var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6299 14.2143C19.17 14.2143 19.5785 13.7883 19.5785 13.2559V8.74415C19.5785 8.21178 19.17 7.77258 18.6299 7.77258C18.0896 7.77258 17.6812 8.21178 17.6812 8.74415V13.2559C17.6812 13.7883 18.0896 14.2143 18.6299 14.2143Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0988 19.8041C15.6258 19.8041 16.0475 19.3781 16.0475 18.8458V3.15431C16.0475 2.62194 15.6258 2.18274 15.0988 2.18274C14.5455 2.18274 14.1502 2.62194 14.1502 3.15431V18.8458C14.1502 19.3781 14.5455 19.8041 15.0988 19.8041Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 16.4368C12.0949 16.4368 12.5033 16.011 12.5033 15.4786V6.5215C12.5033 5.98913 12.0949 5.54993 11.5547 5.54993C11.0145 5.54993 10.6061 5.98913 10.6061 6.5215V15.4786C10.6061 16.011 11.0145 16.4368 11.5547 16.4368Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01055 22C8.55074 22 8.97235 21.5608 8.97235 21.0285V0.971569C8.97235 0.439202 8.55074 0 8.01055 0C7.48354 0 7.0751 0.439202 7.0751 0.971569V21.0285C7.0751 21.5608 7.48354 22 8.01055 22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47958 17.7943C5.01977 17.7943 5.44138 17.3551 5.44138 16.8227V5.17726C5.44138 4.64489 5.01977 4.19238 4.47958 4.19238C3.9394 4.19238 3.53098 4.64489 3.53098 5.17726V16.8227C3.53098 17.3551 3.9394 17.7943 4.47958 17.7943Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935443 13.3625C1.48881 13.3625 1.89724 12.9365 1.89724 12.4042V9.59596C1.89724 9.06359 1.48881 8.62439 0.935443 8.62439C0.408433 8.62439 0 9.06359 0 9.59596V12.4042C0 12.9365 0.408433 13.3625 0.935443 13.3625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarAudio);
export default __webpack_public_path__ + "static/media/tabbar_audio.6e777f834bad5bb7398396af0ba2e870.svg";
export { ForwardRef as ReactComponent };